// libraries
import React from "react";

export function UxAngleUp() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0948 13.45L5.81985 27.3825C5.59824 27.615 5.47461 27.9238 5.47461 28.245C5.47461 28.5662 5.59824 28.875 5.81985 29.1075L5.83485 29.1225C5.94228 29.2356 6.0716 29.3256 6.21493 29.3872C6.35826 29.4487 6.51261 29.4804 6.6686 29.4804C6.82458 29.4804 6.97893 29.4487 7.12227 29.3872C7.2656 29.3256 7.39491 29.2356 7.50235 29.1225L20.0023 16.0025L32.4973 29.1225C32.6048 29.2356 32.7341 29.3256 32.8774 29.3872C33.0208 29.4487 33.1751 29.4804 33.3311 29.4804C33.4871 29.4804 33.6414 29.4487 33.7848 29.3872C33.9281 29.3256 34.0574 29.2356 34.1648 29.1225L34.1798 29.1075C34.4015 28.875 34.5251 28.5662 34.5251 28.245C34.5251 27.9238 34.4015 27.615 34.1798 27.3825L20.9048 13.45C20.7881 13.3275 20.6477 13.2299 20.4921 13.1633C20.3366 13.0966 20.1691 13.0623 19.9998 13.0623C19.8306 13.0623 19.6631 13.0966 19.5076 13.1633C19.352 13.2299 19.2116 13.3275 19.0948 13.45Z"
        fill="#F9F6F1"
      />
    </svg>
  );
}

export function UxAngleDown() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9052 26.55L34.1802 12.6175C34.4018 12.385 34.5254 12.0762 34.5254 11.755C34.5254 11.4338 34.4018 11.125 34.1802 10.8925L34.1652 10.8775C34.0577 10.7644 33.9284 10.6744 33.7851 10.6128C33.6417 10.5513 33.4874 10.5196 33.3314 10.5196C33.1754 10.5196 33.0211 10.5513 32.8777 10.6128C32.7344 10.6744 32.6051 10.7644 32.4977 10.8775L19.9977 23.9975L7.50265 10.8775C7.39522 10.7644 7.2659 10.6744 7.12257 10.6128C6.97924 10.5513 6.82489 10.5196 6.6689 10.5196C6.51292 10.5196 6.35857 10.5513 6.21523 10.6128C6.0719 10.6744 5.94258 10.7644 5.83515 10.8775L5.82015 10.8925C5.59854 11.125 5.47491 11.4338 5.47491 11.755C5.47491 12.0762 5.59854 12.385 5.82015 12.6175L19.0952 26.55C19.2119 26.6725 19.3523 26.7701 19.5079 26.8367C19.6634 26.9034 19.8309 26.9377 20.0002 26.9377C20.1694 26.9377 20.3369 26.9034 20.4924 26.8367C20.648 26.7701 20.7884 26.6725 20.9052 26.55Z"
        fill="#F9F6F1"
      />
    </svg>
  );
}

export function UxAngleLeft() {
  return (
    <svg
      width="12"
      height="22"
      viewBox="0 0 12 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.4176 20.4978C11.1707 20.9918 10.57 21.192 10.076 20.945C6.26214 19.0381 2.48486 15.2608 0.578082 11.447C0.437335 11.1655 0.43733 10.8342 0.57807 10.5527C2.48485 6.73863 6.26214 2.96135 10.076 1.05442C10.57 0.80743 11.1707 1.00765 11.4176 1.50163C11.6646 1.99561 11.4644 2.59628 10.9704 2.84328C7.69265 4.48216 4.3814 7.72215 2.60029 10.9998C4.38141 14.2773 7.69266 17.5172 10.9704 19.1561C11.4644 19.4031 11.6646 20.0038 11.4176 20.4978Z" />
    </svg>
  );
}

export function UxAngleRight() {
  return (
    <svg
      width="12"
      height="22"
      viewBox="0 0 12 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.105792 1.50222C0.352781 1.00825 0.953454 0.808021 1.44743 1.05501C5.2613 2.96194 9.03857 6.73921 10.9454 10.553C11.0861 10.8345 11.0861 11.1658 10.9454 11.4473C9.03859 15.2614 5.2613 19.0386 1.44743 20.9456C0.953454 21.1926 0.352781 20.9923 0.105792 20.4984C-0.141197 20.0044 0.059027 19.4037 0.553006 19.1567C3.83079 17.5178 7.14204 14.2779 8.92315 11.0002C7.14203 7.72273 3.83078 4.48275 0.553006 2.84387C0.059027 2.59688 -0.141197 1.9962 0.105792 1.50222Z" />
    </svg>
  );
}
